import { useAppSelector } from 'hooks/reduxHooks'
import {
  OptimizelyClientSideExperiments,
  useOptimizelyExperiment,
} from 'lib/optimizely/optimizelyUtils'
import { isLEStaff } from 'selectors/accountSelectors'

export const useExploreEnabled = () => {
  const optimizelyEnabled = useOptimizelyExperiment(
    OptimizelyClientSideExperiments.tripExplore,
  )
  const isLeStaffSelector = useAppSelector(isLEStaff)

  return optimizelyEnabled || isLeStaffSelector
}
